module.exports = {"sorry":"Er ging iets mis, onze excuses voor het ongemak.","tryagain":"Opnieuw laden"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/nl-NL/strings.json
// module id = 1179
// module chunks = 0